import { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import SectionHeading from "./SectionHeading";
import About from "../../Assets/Images/scroll_about.png";
import AboutBg from "../../Assets/Images/scroll_about_bg.png";
import Vission from "../../Assets/Images/scroll_vission.png";
import VissionBg from "../../Assets/Images/scroll_vission_bg.png";
import Mission from "../../Assets/Images/scroll_mission.png";
import MissionBg from "../../Assets/Images/scroll_mission_bg.png";

// Section data
const sections = [
  {
    id: "about",
    title: "ABOUT US",
    description:
      "With successful events and strong industry connections, we have established ourselves as a reliable and professional event management company.",
    image: About,
    imageBg: AboutBg,
  },
  {
    id: "vission",
    title: "VISION",
    description:
      "Reach out to us for any queries or event-related assistance. We are happy to help!",
    image: Vission,
    imageBg: VissionBg,
  },
  {
    id: "mission",
    title: "MISSION",
    description:
      "Reach out to us for any queries or event-related assistance. We are happy to help!",
    image: Mission,
    imageBg: MissionBg,
  },
];

function SectionShowcase() {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if the device is mobile or desktop
  useEffect(() => {
    const checkMobileView = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobileView(); // Initial check
    window.addEventListener("resize", checkMobileView); // Event listener for resizing
    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  const extendedSections = [...sections, ...sections];

  const onSlideChange = (swiper) => {
    // Adjust activeIndex according to the extendedSections
    const index = swiper.realIndex % sections.length;
    setActiveIndex(index);
  };

  const bgImage = sections[activeIndex]?.imageBg || "";
  const [prevBg, setPrevBg] = useState(bgImage); // Track the previous background
  const [fadeBg, setFadeBg] = useState(false); // Control opacity class

  useEffect(() => {
    if (prevBg !== bgImage) {
      setFadeBg(true); // Trigger fade-out of current and fade-in of new
      const timeout = setTimeout(() => {
        setPrevBg(bgImage); // Update the previous background once fade completes
        setFadeBg(false); // Reset fade state
      }, 1000); // match with transition duration

      return () => clearTimeout(timeout);
    }
  }, [bgImage, prevBg]);

  return (
    <div className="section-showcase-wrapper rounded-0 position-relative">
      {/* Previous background (fading out) */}
      <div
        className={`background-fader position-absolute top-0 start-0 w-100 h-100 ${
          fadeBg ? "fade-out" : ""
        }`}
        style={{
          backgroundImage: !isMobile
            ? `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${prevBg})`
            : "none",
          zIndex: 0,
        }}
      />

      {/* Current background (fading in) */}
      <div
        className={`background-fader position-absolute top-0 start-0 w-100 h-100 ${
          fadeBg ? "fade-in" : ""
        }`}
        style={{
          backgroundImage: !isMobile
            ? `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${bgImage})`
            : "none",
          zIndex: 0,
        }}
      />

      {/* Swiper Section in Foreground */}
      <div className="position-relative w-100 z-1">
        <Swiper
          loop={true}
          slidesPerView={isMobile ? 1 : 2.5}
          centeredSlides={true}
          onSlideChange={onSlideChange}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className="swiper-container"
          spaceBetween={isMobile ? 10 : 0}
          speed={2000}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 1.5, spaceBetween: 20 },
            1200: { slidesPerView: 2.5 },
          }}>
          {extendedSections.map((section, i) => {
            const isLeft = i === activeIndex - 1;
            const isRight = i === activeIndex + 1;

            return (
              <SwiperSlide
                key={`${section.id}-${i}`}
                onClick={() =>
                  swiperRef.current?.slideToLoop(i % sections.length)
                }
                className="swiper-slide">
                <div
                  className={`card ${
                    sections[activeIndex].id === section.id
                      ? "active"
                      : "inactive"
                  } 
                  ${isLeft ? "left-inactive" : ""} 
                  ${isRight ? "right-inactive" : ""} 
                  rounded-0 card-swiper`}>
                  <img
                    src={section.image}
                    alt={section.title}
                    className={`card-image rounded-0 ${
                      sections[activeIndex].id === section.id
                        ? "fade-in"
                        : "fade-out"
                    }`}
                  />
                  {/* <div className="p-4">
                <h3>{section.title}</h3>
                {sections[activeIndex].id === section.id && (
                  <p>{section.description}</p>
                )}
              </div> */}
                  <div className="p-4">
                    <h3>{section.title}</h3>
                    {sections[activeIndex].id === section.id && (
                      <p>{section.description}</p>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}

function HomeAbout() {
  return (
    <div className="home-about-section ">
      <SectionHeading
        secTitle="About Us"
        secIndex="Professionalism meets perfection!"
      />
      <SectionShowcase />
    </div>
  );
}

export default HomeAbout;
